import { Injectable, Optional, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AddressModel } from '../models/address.model';
import { ClassModel } from '../models/class.model';
import { ActivityModel } from '../models/crm-model/activity.model';
import { ConnectionModel } from '../models/crm-model/connection.model';
import { CompanyModel } from '../models/finance/company.model';
import { InstructorModel } from '../models/instructor.model';
import { LessonModel } from '../models/lesson.model';
import { RoleModel } from '../models/role.model';
import { StudentModel } from '../models/student.model';
import { TenantModel } from '../models/tenant.model';
// import { PostType } from 'src/app/core/models/post-type.model';
// import { PostTypeService } from './post-type.service';

@Injectable({
  providedIn: 'root'
})
export class RouteStateService {
  //https://medium.com/@tomastrajan/how-to-get-route-path-parameters-in-non-routed-angular-components-32fc90d9cb52

  private termIDState = new BehaviorSubject<string>(null);
  termID: Observable<string> = this.termIDState.asObservable();

  private courseIDState = new BehaviorSubject<string>(null);
  courseID: Observable<string> = this.courseIDState.asObservable();

  private classIDState = new BehaviorSubject<string>(null);
  classID: Observable<string> = this.classIDState.asObservable();

  private trainingIDState = new BehaviorSubject<string>(null);
  trainingID: Observable<string> = this.trainingIDState.asObservable();

  private studentIDState = new BehaviorSubject<string>(null);
  studentID: Observable<string> = this.studentIDState.asObservable();
  private companyIDState = new BehaviorSubject<string>(null);
  companyID: Observable<string> = this.companyIDState.asObservable();
  private trainingTypeIDState = new BehaviorSubject<string>(null);
  trainingTypeID: Observable<string> = this.trainingTypeIDState.asObservable();
  private instructorIDState = new BehaviorSubject<string>(null);
  instructorID: Observable<string> = this.instructorIDState.asObservable();
  private parentIDState = new BehaviorSubject<string>(null);
  parentID: Observable<string> = this.parentIDState.asObservable();

  private safeBoxIDState = new BehaviorSubject<string>(null);
  safeBoxID: Observable<string> = this.safeBoxIDState.asObservable();


  private tenantIDState = new BehaviorSubject<string>(null);
  tenantID: Observable<string> = this.tenantIDState.asObservable();

  private lessonIDState = new BehaviorSubject<string>(null);
  lessonID: Observable<string> = this.lessonIDState.asObservable();

  private classModelState = new BehaviorSubject<ClassModel>(null);
  classModel: Observable<ClassModel> = this.classModelState.asObservable();

  private tenantModelState = new BehaviorSubject<TenantModel>(null);
  tenantModel: Observable<TenantModel> = this.tenantModelState.asObservable();

  private lessonModelState = new BehaviorSubject<LessonModel>(null);
  lessonModel: Observable<LessonModel> = this.lessonModelState.asObservable();

  private classLevelIDState = new BehaviorSubject<string>(null);
  classLevelID: Observable<string> = this.classLevelIDState.asObservable();

  private roleIDState = new BehaviorSubject<string>(null);
  roleID: Observable<string> = this.roleIDState.asObservable();

  private breadcrumbServiceState = new BehaviorSubject(null);
  breadcrumbService: Observable<any> = this.breadcrumbServiceState.asObservable();

  private instructorModelState = new BehaviorSubject<InstructorModel>(null);
  instructorModel: Observable<InstructorModel> = this.instructorModelState.asObservable();

  private studentModelState = new BehaviorSubject<{Student: StudentModel, Address: AddressModel, Company: CompanyModel, ClassID}>(null);
  studentModel: Observable<{Student: StudentModel, Address: AddressModel, Company: CompanyModel, ClassID}> = this.studentModelState.asObservable();

  private tenantRolesState = new BehaviorSubject<RoleModel[]>(null);
  tenantRoles: Observable<RoleModel[]> = this.tenantRolesState.asObservable();

  private roleModelState = new BehaviorSubject<RoleModel>(null);
  roleModel: Observable<RoleModel> = this.roleModelState.asObservable();

  private profilePhotoState = new BehaviorSubject<string>(null);
  UserPhoto: Observable<string> = this.profilePhotoState.asObservable();

  private connectionModelState = new BehaviorSubject<ConnectionModel>(null);
  connectionModel: Observable<ConnectionModel> = this.connectionModelState.asObservable();

  private activityModelState = new BehaviorSubject<ActivityModel>(null);
  activityModel: Observable<ActivityModel> = this.activityModelState.asObservable();
  private virtualPageState = new BehaviorSubject<string>(null);
  virtualPage: Observable<string> = this.virtualPageState.asObservable();

  private virtualPageStatuState = new BehaviorSubject<string>(null);
  virtualPageStatu: Observable<string> = this.virtualPageStatuState.asObservable();
  private reportImageState = new BehaviorSubject<string>(null);
  reportImageStatu: Observable<string> = this.reportImageState.asObservable();

  constructor() {
    
  }

  updateTermID(nextTermID: string) {
    this.termIDState.next(nextTermID);
  }

  updateReportImage(imageBase64: string) {
    this.reportImageState.next(imageBase64);
  }

  updateCourseID(nextCourseID: string) {
    this.courseIDState.next(nextCourseID);
  }

  updateClassID(nextClassID: string) {
    this.classIDState.next(nextClassID);
  }

  updateTrainingID(nextTrainingID: string) {
    this.trainingIDState.next(nextTrainingID);
  }

  updateSafeBoxID(nextSafeBoxID: string) {
    this.safeBoxIDState.next(nextSafeBoxID);
  }

  updateTenantID(nextTenantID: string) {
    this.tenantIDState.next(nextTenantID);
  }

  updateLessonID(nextLessonID: string) {
    this.lessonIDState.next(nextLessonID);
  }

  updateStudentID(nextStudentID: string) {
    this.studentIDState.next(nextStudentID);
  }
  updateInstructorID(nextInstructorID: string) {
    this.instructorIDState.next(nextInstructorID);
  }
  updateCompanyID(nextCompanyID: string) {
    this.companyIDState.next(nextCompanyID);
  }

  updateTrainingTypeID(nextTrainingTypeID: string) {
    this.trainingTypeIDState.next(nextTrainingTypeID);
  }

  updateParentID(nextParentID: string) {
    this.parentIDState.next(nextParentID);
  }

  updateClassModel(nextClassModel: ClassModel) {
    this.classModelState.next(nextClassModel);
  }

  updateTenantModel(nextTenantModel: TenantModel) {
    this.tenantModelState.next(nextTenantModel);
  }

  updateLessonModel(nextLessonModel: LessonModel) {
    this.lessonModelState.next(nextLessonModel);
  }

  updateClassLevelID(nextClassLevelID: string) {
    this.classLevelIDState.next(nextClassLevelID);
  }

  updateRoleID(nextRoleID: string) {
    this.roleIDState.next(nextRoleID);
  }

  updateBreadcrumbs() {
    this.breadcrumbServiceState.next(null);
  }

  updateInstructorModel(nextInstructorModel: InstructorModel) {
    this.instructorModelState.next(nextInstructorModel);
  }

  updateConnectionModel(nextConnectionModel: ConnectionModel) {
    this.connectionModelState.next(nextConnectionModel);
  }
  updateActivityModel(nextActivityModel: ActivityModel) {
    this.activityModelState.next(nextActivityModel);
  }

  updateStudentModel(nextStudentModel: {Student: StudentModel, Address: AddressModel, Company: CompanyModel, ClassID}) {
    this.studentModelState.next(nextStudentModel);
  }


  updateTenantRoles(nextRoles: RoleModel[]) {
    this.tenantRolesState.next(nextRoles);
  }

  updateRoleModel(nextRoleModel: RoleModel) {
    this.roleModelState.next(nextRoleModel);
  }

  updateProfilePhoto(UserPhoto: string) {
    this.profilePhotoState.next(UserPhoto);
  }

  virtualPageUpdate(Url: string) {
    this.virtualPageState.next(Url);
  }

  virtualPageStatuUpdate(status: string) {
    this.virtualPageStatuState.next(status);
  }

}
